import React from 'react'
import EyeHideSolid from '../../../Icon/icons/EyeHideSolid'
import EyeShowSolid from '../../../Icon/icons/EyeShowSolid'

interface ToggleSwitchProps {
  checked: boolean
  onChange: (checked: boolean) => void
  label: string
  showEyeIcon?: boolean
}

function ToggleSwitch ({
  checked, onChange, label, showEyeIcon,
}: ToggleSwitchProps) {
  return (
    <label className="toggle-switch">
      <span className="toggle-switch__label">{label}</span>
      <button
        type="button"
        role="switch"
        aria-checked={checked}
        className={`toggle-switch__track ${checked ? 'toggle-switch__track--on' : ''}`}
        onClick={() => onChange(!checked)}
      >
        <span className="toggle-switch__knob">
          {showEyeIcon && (
            <>
              <span
                className={`toggle-switch__knob-icon ${
                  checked
                    ? 'toggle-switch__knob-icon--hidden'
                    : 'toggle-switch__knob-icon--visible'
                }`}
                aria-hidden="true"
              >
                <EyeHideSolid size={24} color="currentColor" />
              </span>
              <span
                className={`toggle-switch__knob-icon ${
                  checked
                    ? 'toggle-switch__knob-icon--visible'
                    : 'toggle-switch__knob-icon--hidden'
                }`}
                aria-hidden="true"
              >
                <EyeShowSolid size={24} color="currentColor" />
              </span>
            </>
          )}
        </span>
      </button>
    </label>
  )
}

export default React.memo(ToggleSwitch)
